/**
 * «Юниверситет» (28.09): общие мелочи движка — контекст подписанных ссылок на медиа,
 * перемешивание и числительные. Без сети и без хранения.
 */
import { createContext, useContext } from "react";

/** rel из пакета («media/…», «tracks/…», «badges/…») → абсолютная подписанная ссылка. */
export type MediaUrl = (rel: string | undefined | null) => string | undefined;

export const UniMediaCtx = createContext<MediaUrl>(() => undefined);
export const useMediaUrl = () => useContext(UniMediaCtx);

/** Перемешивание Фишера–Йетса: новая копия, исходник не трогаем. */
export function shuffle<T>(src: readonly T[]): T[] {
  const a = [...src];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j]!, a[i]!];
  }
  return a;
}

/** Обложка ролика — тот же путь с .jpg (так собран пакет). */
export const posterOf = (video: string) => video.replace(/\.mp4$/i, ".jpg");

/** «Три коротких вопроса» — из daily.count, а не зашитой тройкой. */
export function questionsWord(n: number): string {
  const words = ["Один короткий вопрос", "Два коротких вопроса", "Три коротких вопроса", "Четыре коротких вопроса"];
  return words[n - 1] ?? `${n} коротких вопросов`;
}

/** Запись в localStorage, которая не роняет экран (приватный режим, запрет хранилища). */
export function lsGet(key: string): string | null {
  try { return localStorage.getItem(key); } catch { return null; }
}
export function lsSet(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch { /* хранилище недоступно — живём без черновика */ }
}
